import {computed, observable} from 'mobx'

export default class Category {
    @observable id = 0
    @observable left_key = 0
    @observable right_key = 0
    @observable depth = 0
    @observable name = ''
    @observable parent_id = 0
    @observable status = true
    @observable include_sub_categories = false
    @observable type = 0

    /**
     * @param {Object} category
     */
    constructor(category) {
        if (category) {
            this.id = parseInt(category.id)
            this.left_key = parseInt(category.left_key)
            this.right_key = parseInt(category.right_key)
            this.depth = parseInt(category.depth)
            this.name = category.name
            this.parent_id = parseInt(category.parent_id)
            this.status = category.status
            this.include_sub_categories = category.include_sub_categories
            this.type = parseInt(category.type)
        }
    }

    @computed get is_static() {
        return this.type === 0
    }

    /**
     * @param {Category} category
     * @return {boolean}
     */
    isChildOf(category) {
        return category.left_key < this.left_key && category.right_key > this.right_key
    }
}
